import { InjectionToken } from '@angular/core';

export const IS_MOCK_MODE = new InjectionToken<boolean>('IS_MOCK_MODE', {
    factory: () => false,
});

